import { Component, OnInit, Input, OnDestroy } from '@angular/core';

declare var jquery: any;
declare var $: any;

@Component({
	selector: 'app-customize-panel',
	templateUrl: './customize-panel.component.html',
	styleUrls: ['./customize-panel.component.css']
})
export class CustomizePanelComponent implements OnInit, OnDestroy {

	@Input() data: object|any;

	constructor() { }

	ngOnInit() {
		if (this.data['show']) {
			if ($(".customize-page-popup").css('display') == 'none') {
				/* Adding over lays to all side panel by default */
				$('.side-overlay').each(function(i:any,data:any) {
					$(data).removeClass('box-overlay');
					$(data).addClass('box-overlay-show');
				});
			} else {
				/* Removing over lays to all side panel by default */
				$('.side-overlay').each(function(i:any,data:any) {
					$(data).removeClass('box-overlay-show');
					$(data).addClass('box-overlay');
				});
				/* Removing over lays to all side panel by default */
				$('.center-overlay').each(function(i:any,data:any) {
					$(data).removeClass('box-overlay-show');
					$(data).addClass('box-overlay');
				});
			}
			$(".customize-page-popup").slideToggle('show');
		}
	}

	// ngOnChanges(change: SimpleChanges) {
	// 	console.log(change);
	// 	if (!change.data['showshow'].firstChange) {
	// 		if ($(".customize-page-popup").css('display') == 'none') {
	// 			/* Adding over lays to all side panel by default */
	// 			$('.side-overlay').each(function(i,data) {
	// 				$(data).removeClass('box-overlay');
	// 				$(data).addClass('box-overlay-show');
	// 			});
	// 		} else {
	// 			 Removing over lays to all side panel by default 
	// 			$('.side-overlay').each(function(i,data) {
	// 				$(data).removeClass('box-overlay-show');
	// 				$(data).addClass('box-overlay');
	// 			});
	// 			/* Removing over lays to all side panel by default */
	// 			$('.center-overlay').each(function(i,data) {
	// 				$(data).removeClass('box-overlay-show');
	// 				$(data).addClass('box-overlay');
	// 			});
	// 		}
	// 		$(".customize-page-popup").slideToggle('show');
	// 	}
	// }


	ngOnDestroy() {
		/* Removing over lays to all side panel by default */
		$('.side-overlay').each(function(i:any,data:any) {
			$(data).removeClass('box-overlay-show');
			$(data).addClass('box-overlay');
		});
		/* Removing over lays to all side panel by default */
		$('.center-overlay').each(function(i:any,data:any) {
			$(data).removeClass('box-overlay-show');
			$(data).addClass('box-overlay');
		});
	}

	openSideWidget() {
		/* Adding over lays to all side panel by default */
		$('.side-overlay').each(function(i:any,data:any) {
			$(data).removeClass('box-overlay');
			$(data).addClass('box-overlay-show');
		});
		/* Removing over lays to all side panel by default */
		$('.center-overlay').each(function(i:any,data:any) {
			$(data).removeClass('box-overlay-show');
			$(data).addClass('box-overlay');
		});
	}

	openCenterWidget() {
		/* Adding over lays to all side panel by default */
		$('.center-overlay').each(function(i:any,data:any) {
			$(data).removeClass('box-overlay');
			$(data).addClass('box-overlay-show');
		});
		/* Removing over lays to all side panel by default */
		$('.side-overlay').each(function(i:any,data:any) {
			$(data).removeClass('box-overlay-show');
			$(data).addClass('box-overlay');
		});
	}

	onDragStart(ev: Event|any, wLoc: string) {
		ev['dataTransfer'].setData("text", ev.currentTarget['id']+'-'+wLoc);
	}
}
